"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Progress;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _rcProgress = require("rc-progress");
var _ykbStyledComponents = require("../ykb-styled-components");
var _classnames = _interopRequireDefault(require("classnames"));
var _StyledProgress = require("./StyledProgress");
var _excluded = ["prefixCls", "className", "percent", "status", "format", "trailColor", "size", "successPercent", "type", "strokeWidth", "width", "showInfo", "gapDegree", "gapPosition", "strokeColor", "showIconOnSuccess", "rightLabelText", "leftLabelText"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var statusColorMap = {
  normal: '#108ee9',
  exception: '#f24739',
  success: '#26ba5c'
};
var validProgress = function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  } else if (progress > 100) {
    return 100;
  }
  return progress;
};
function Progress(props) {
  var prefixCls = props.prefixCls,
    className = props.className,
    _props$percent = props.percent,
    percent = _props$percent === void 0 ? 0 : _props$percent,
    status = props.status,
    format = props.format,
    trailColor = props.trailColor,
    size = props.size,
    successPercent = props.successPercent,
    type = props.type,
    strokeWidth = props.strokeWidth,
    width = props.width,
    showInfo = props.showInfo,
    _props$gapDegree = props.gapDegree,
    gapDegree = _props$gapDegree === void 0 ? 0 : _props$gapDegree,
    gapPosition = props.gapPosition,
    strokeColor = props.strokeColor,
    showIconOnSuccess = props.showIconOnSuccess,
    rightLabelText = props.rightLabelText,
    leftLabelText = props.leftLabelText,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var progressStatus = parseInt(successPercent ? successPercent.toString() : percent.toString(), 10) >= 100 && !('status' in props) ? 'success' : status || 'normal';
  var progressInfo;
  var progress;
  var textFormatter = format || function (percentNumber) {
    return "".concat(percentNumber, "%");
  };
  var iconSize;
  if (width && type !== 'line') {
    iconSize = width / 4;
  } else if (type === 'line') {
    iconSize = 14;
  } else {
    iconSize = 32;
  }
  if (showInfo) {
    var text;
    var iconType = type === 'circle' || type === 'dashboard' ? '' : '-circle';
    if (format || progressStatus !== 'exception' && progressStatus !== 'success' || progressStatus === 'success' && !showIconOnSuccess) {
      text = textFormatter(validProgress(percent), validProgress(successPercent));
    } else if (progressStatus === 'exception') {
      text = /*#__PURE__*/React.createElement(_Icon.default, {
        name: "close".concat(iconType),
        className: "ykb-icon",
        size: iconSize
      });
    } else if (progressStatus === 'success') {
      text = /*#__PURE__*/React.createElement(_Icon.default, {
        name: "check".concat(iconType),
        className: "ykb-icon",
        size: iconSize
      });
    }
    progressInfo = /*#__PURE__*/React.createElement(_StyledProgress.ProgressText, {
      className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-text"), !!prefixCls))
    }, text);
  }
  if (type === 'line') {
    var percentStyle = {
      width: "".concat(validProgress(percent), "%"),
      height: strokeWidth || (size === 'small' ? 6 : 8),
      background: strokeColor
    };
    var successPercentStyle = {
      width: "".concat(validProgress(successPercent), "%"),
      height: strokeWidth || (size === 'small' ? 6 : 8)
    };
    var successSegment = successPercent !== undefined ? /*#__PURE__*/React.createElement(_StyledProgress.ProgressSuccessBg, {
      className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-success-bg"), !!prefixCls)),
      style: successPercentStyle
    }) : null;
    progress = /*#__PURE__*/React.createElement("div", null, leftLabelText && /*#__PURE__*/React.createElement(_StyledProgress.ProgressLabel, {
      className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-label-left"), !!prefixCls))
    }, leftLabelText), rightLabelText && /*#__PURE__*/React.createElement(_StyledProgress.ProgressLabel, {
      rightLabelText: rightLabelText,
      $showInfo: showInfo,
      className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-label-right"), !!prefixCls))
    }, rightLabelText), /*#__PURE__*/React.createElement(_StyledProgress.ProgressOuter, {
      className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-outer"), !!prefixCls))
    }, /*#__PURE__*/React.createElement(_StyledProgress.ProgressInner, {
      className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-inner"), !!prefixCls))
    }, /*#__PURE__*/React.createElement(_StyledProgress.ProgressBg, {
      className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-bg"), !!prefixCls)),
      style: percentStyle
    }, successSegment))), progressInfo);
  } else if (type === 'circle' || type === 'dashboard') {
    var circleSize = width || 120;
    var circleStyle = {
      width: circleSize,
      height: circleSize,
      fontSize: circleSize * 0.15 + 6
    };
    var circleWidth = strokeWidth || 6;
    var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';
    var gapDeg = gapDegree || type === 'dashboard' && 75;
    progress = /*#__PURE__*/React.createElement(_StyledProgress.ProgressInner, {
      className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-inner"), !!prefixCls)),
      style: circleStyle
    }, /*#__PURE__*/React.createElement(_rcProgress.Circle, {
      percent: validProgress(percent),
      strokeWidth: circleWidth,
      trailWidth: circleWidth,
      strokeColor: strokeColor || statusColorMap[progressStatus],
      trailColor: trailColor,
      prefixCls: prefixCls,
      gapDegree: gapDeg,
      gapPosition: gapPos
    }), progressInfo);
  }
  var classString = (0, _classnames.default)(prefixCls, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-").concat(type === 'dashboard' && 'circle' || type), !!prefixCls), "".concat(prefixCls, "-status-").concat(progressStatus), !!prefixCls), "".concat(prefixCls, "-show-info"), !!prefixCls && showInfo), "".concat(prefixCls, "-").concat(size), !!prefixCls && size), className);
  return /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/React.createElement(_StyledProgress.StyledProgress, (0, _extends2.default)({}, restProps, {
      theme: theme,
      $progressStatus: progressStatus,
      $type: type,
      $size: size,
      $showInfo: showInfo,
      className: classString,
      $strokeColor: strokeColor
    }), progress);
  });
}

// Progress.Line;
// Progress.Circle;

Progress.defaultProps = {
  type: 'line',
  percent: 0,
  showInfo: true,
  trailColor: '#f3f3f3',
  prefixCls: 'ykb-progress',
  size: 'default',
  showIconOnSuccess: false,
  rightLabelText: '',
  leftLabelText: ''
};
Progress.propTypes = {
  status: _propTypes.default.oneOf(['normal', 'exception', 'active', 'success']),
  type: _propTypes.default.oneOf(['line', 'circle', 'dashboard']),
  showInfo: _propTypes.default.bool,
  showIconOnSuccess: _propTypes.default.bool,
  percent: _propTypes.default.number,
  width: _propTypes.default.number,
  strokeWidth: _propTypes.default.number,
  strokeColor: _propTypes.default.string,
  trailColor: _propTypes.default.string,
  format: _propTypes.default.func,
  gapDegree: _propTypes.default.number,
  default: _propTypes.default.oneOf(['default', 'small']),
  rightLabelText: _propTypes.default.string,
  leftLabelText: _propTypes.default.string
};